export function RightsOfTheDataSubject() {
  return (
    <p>
      <ul>
        <li> the right to be informed about the collection and use of your personal data;</li>
        <li> the right of access to your personal data and any supplementary information;</li>
        <li> the right to have any errors in your personal data rectified;</li>
        <li> the right to have your personal data erased;</li>
        <li> the right to block or suppressing the processing of your personal data;</li>
        <li> the right to move, copy or transfer your personal data from one IT environment to another;</li>
        <li> the right to object to processing of your personal data in certain circumstances, and rights related to automated decision-making (i.e. where no humans are involved) and profiling (i.e. where certain personal data is processed to evaluate an individual).</li>
      </ul>
    </p>
  );
}

export default RightsOfTheDataSubject;
